import RegistroProvider from 'contexts/registroContext/RegistroContext';
import {
  FullHeightContainer,
  FundacaoLogo,
  Header,
  HeaderType,
  IconButton,
} from 'plataforma-fundacao-componentes';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default function Layout({ children }: { children: JSX.Element }) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={window.env.reCaptchaKeyV3}
      language='pt-BR'
    >
      <RegistroProvider>
        <FullHeightContainer
          header={
            <Header
              position='static'
              theme={HeaderType.Branco}
              leftContent={
                <IconButton
                  onClick={() => {
                    window.location.replace(window.env.fundacao);
                  }}
                  id='home-icon'
                  icon={<FundacaoLogo height={45} />}
                />
              }
            />
          }
        >
          {children}
        </FullHeightContainer>
      </RegistroProvider>
    </GoogleReCaptchaProvider>
  );
}
